import React, { HTMLAttributes, useMemo } from "react";
import { observer } from "mobx-react-lite";
import cx from "classnames";
import { Hooks, Util } from "@xt/xtbase";
const { useTranslation } = Hooks;
const { Big } = Util;
import store from "store";

import styles from "./index.module.scss";

interface Props extends HTMLAttributes<HTMLDivElement> {
  attr?: any;
}

const Main: React.FC<Props> = ({ className, ...rest }) => {
  const t = useTranslation();
  const { leverAccountOverview } = store.balances;
  const { tradeRecent } = store.trade;

  const valueLabel = useMemo(() => {
    if (!leverAccountOverview || isNaN(+leverAccountOverview.liquidationPrice) || !tradeRecent || !tradeRecent.p) return "--";

    return Big(leverAccountOverview.liquidationPrice || 0)
      .minus(tradeRecent.p)
      .div(tradeRecent.p)
      .times(100)
      .toFixed(2);
  }, [leverAccountOverview, tradeRecent]);

  return (
    <div className={cx(styles.main, className)} {...rest}>
      <div>
        <span>{t("trade.toLiqPrice")}</span>:
      </div>
      <div>{valueLabel}%</div>
    </div>
  );
};

export default observer(Main);
// export default Main;
